module.exports = __webpack_public_path__ + "static/media/palmeria-beauty-project.e858ebde.png";